import { ModalBody } from "@components/shared/Modal";
import React from "react";
import { SeatMap, SeatMapProps } from "./SeatMap";

export type SeatSelectionModalBodyProps = SeatMapProps;

export const SeatSelectionModalBody: React.FC<SeatSelectionModalBodyProps> = (
  props,
) => (
  <ModalBody>
    <SeatMap {...props} />
  </ModalBody>
);
;
import "/Users/igordepaula/.yarn/berry/cache/@sentry-bundler-plugin-core-npm-0.7.2-054e3436fd-10c0.zip/node_modules/@sentry/bundler-plugin-core/sentry-release-injection-file.js";